import { gql } from '@apollo/client'
// 获取资源包

export const GET_MIRROR_TEMPLATE_LIST = gql`
  query getMirrorTemplateList {
    mirrorMarketQuery {
      homeResourcePackage {
        categoryList {
          id
          name
          itemList {
            id
            image
            name
          }
        }
      }
    }
  }
`
